<div class="activar-container">
  <div class="activar-card">
    <div class="activar-brand">
      <img src="/assets/shell/logos/logo-nebula.svg" alt="Nebula ERP" class="activar-logo" />
    </div>

    <!-- Formulario de definición de la nueva contraseña -->
    @if (estado() === 'formulario' || estado() === 'enviando') {
      <h2>{{ 'CHANGE_PWD.TITLE' | translate }}</h2>
      <p class="activar-sub">{{ 'CHANGE_PWD.SUBTITLE' | translate }}</p>

      <form [formGroup]="form" (ngSubmit)="guardar()" class="activar-form">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'CHANGE_PWD.NEW' | translate }}</mat-label>
          <input
            matInput
            [type]="hideNew ? 'password' : 'text'"
            formControlName="password"
            autocomplete="new-password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideNew = !hideNew"
            [attr.aria-label]="'CHANGE_PWD.NEW' | translate"
          >
            <mat-icon>{{ hideNew ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (form.get('password')?.hasError('required') && form.get('password')?.touched) {
            <mat-error>{{ 'CHANGE_PWD.REQUIRED' | translate }}</mat-error>
          }
          @if (form.get('password')?.hasError('minlength')) {
            <mat-error>{{ 'CHANGE_PWD.MIN' | translate }}</mat-error>
          }
          @if (form.get('password')?.hasError('pattern')) {
            <mat-error>{{ 'CHANGE_PWD.COMPLEXITY' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'CHANGE_PWD.CONFIRM' | translate }}</mat-label>
          <input
            matInput
            [type]="hideConfirm ? 'password' : 'text'"
            formControlName="confirmar"
            autocomplete="new-password"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="hideConfirm = !hideConfirm"
            [attr.aria-label]="'CHANGE_PWD.CONFIRM' | translate"
          >
            <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (form.hasError('noCoinciden') && form.get('confirmar')?.touched) {
            <mat-error>{{ 'CHANGE_PWD.NO_MATCH' | translate }}</mat-error>
          }
        </mat-form-field>

        <ul class="activar-politica">
          <li>{{ 'CHANGE_PWD.RULE_LENGTH' | translate }}</li>
          <li>{{ 'CHANGE_PWD.RULE_CASE' | translate }}</li>
          <li>{{ 'CHANGE_PWD.RULE_NUM_SYM' | translate }}</li>
        </ul>

        @if (error()) {
          <div class="activar-error">{{ error() }}</div>
        }

        <button
          mat-flat-button
          color="primary"
          type="submit"
          class="activar-boton"
          [disabled]="estado() === 'enviando'"
        >
          @if (estado() === 'enviando') {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            {{ 'CHANGE_PWD.SUBMIT' | translate }}
          }
        </button>
      </form>
    }

    <!-- Cambio completado -->
    @if (estado() === 'listo') {
      <div class="activar-estado">
        <mat-icon class="icono-ok">check_circle</mat-icon>
        <h2>{{ 'CHANGE_PWD.DONE_TITLE' | translate }}</h2>
        <p>{{ 'CHANGE_PWD.DONE_SUBTITLE' | translate }}</p>
      </div>
    }
  </div>
</div>
